import React, {useState, useEffect} from "react"

import {IoAddOutline, IoRefreshOutline} from "react-icons/io5";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

// import {fetchTasks} from "../../../actions/tasks";
// import {fetchTasks} from "../../../actions/tasks";
import { fetchTasks } from "../../../../redux/actions";

import {useDispatch} from "react-redux";
import Form from 'react-bootstrap/Form';
import Modal from "../../../../modals/Modal";
import { baseURL } from "../../../../helpers/baseURL";
import successAlert from "../../../../helpers/successAlert";
import failAlert from "../../../../helpers/failAlert";
import { Button } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IoInformationCircleOutline } from "react-icons/io5";
import { formatDateOnly } from "../../../../helpers/formatDate";

const LinkTask = ({ isOpen, hideModal, ticketId, currentState}) => {
    const dispatch = useDispatch()
    const [results, setResults] = useState([])
    const [query, setQuery] = useState()
    const [isLoading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] =useState();
    const [syncFiles, setSyncFiles] = useState(true)
    const [recentTasks, setRecentTasks] = useState([])
    const [recentLoading, setRecentLoading] = useState(false)

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const renderSyncTooltip = (props) => (
        <Tooltip id="sync-files-tooltip" {...props}>
            When enabled, all current and future ticket attachments will be synced to this Claritask task.
            Turn it off if you don’t want ticket files uploaded to Claritask.
        </Tooltip>
    );


    const fetchRecentTasks = () => {
        setRecentLoading(true)
        axios.get(`${baseURL}recent-tasks`,{headers:{Authorization: `Bearer ${Cookies.get('access_token')}`}})
            .then(res => {
                setRecentTasks(res.data.data.tasks ?? [])
                setRecentLoading(false)
            })
            .catch((err) => {
                console.error(err)
                setRecentLoading(false)
            })
    }

    useEffect(() => {
        if (isOpen) {
            fetchRecentTasks()
        } else {
            setResults([])
            setQuery('')
            setSelectedValue(undefined)
            setSyncFiles(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen])

    const searchForTasks = (e) => {
        e.preventDefault()
        axios.get(`${baseURL}search-task?search=${query}`,{headers:{Authorization: `Bearer ${Cookies.get('access_token')}`}})
            .then(res => {
               setResults(res.data.data.tasks)
            })
            .catch((err) => console.error(err))
    }

    const linkTicket = (taskIdOverride) => {
        let claritask_task_id = taskIdOverride ?? selectedValue
        const id = ticketId ?? currentState?.details?.id
        if (!id || !claritask_task_id) return

        setLoading(true)
        axios.post(`${baseURL}link-ticket/${id}`, {claritask_task_id, sync_files: syncFiles ? 1: 0},{headers:{Authorization: `Bearer ${Cookies.get('access_token')}`}})
            .then(res => {
                dispatch(fetchTasks(id))
                hideModal()
                successAlert('Task linked successfully');
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
                failAlert(err.response?.data?.message || 'Something went wrong. Please try again later.');
            })
    }

    const linkRecentTask = (task) => {
        setSelectedValue(task.task_id)
        linkTicket(task.task_id)
    }

    return(
        isOpen && (
            <Modal>
                <div className="modal d-block" onClick={hideModal}>
                    <section className="create-task-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="px-0 modal-header modal-header-claritask align-items-center">
                            <div className="d-block text-center modal-header-claritask-header">
                                <h5 className="ml-0">Link Task</h5>
                            </div>
                            <IoAddOutline onClick={hideModal} className="modal-header-claritask-x"/>
                        </div>
                        <div className="modal-body px-0">
                            <div className="claritask-create-div">
                                <form onSubmit={(e) => searchForTasks(e)}>
                                    <p className="mb-1 font_main_p">Search tasks in Claritask</p>
                                    <input type="search" placeholder="Enter a task name to search" onChange={(e) => setQuery(e.target.value)}/>
                                    <button className="btn search-task-cs" type="submit">Search</button>
                                </form>
                            </div>
                            {results.length > 0 &&
                            <div className="tasks-results-cs">
                                {results.map(res => {
                                    return(
                                        <div key={res.task_id} className={selectedValue == res.task_id ? 'selected-task' : ""}>
                                            <Form.Label className="d-flex align-items-center">   
                                                <Form.Check
                                                    type={"radio"}
                                                    id={`check-api-radio`}
                                                    checked={selectedValue == res.task_id}
                                                    value={res.task_id}
                                                    onChange={handleChange}
                                                    name="radio-button-demo"
                                                    className="me-2"
                                                />
                                                <div>
                                                    {res.task_text.length > 100
                                                    ? `${res.task_text.substring(0, 100)}...`
                                                    : res.task_text}
                                                </div>
                                            </Form.Label>
                                        </div>
                                        
                                    )
                                })}
                               <div className="sync-files-row">
                                    <div className="d-flex align-items-center">
                                        <span className="sync-files-label">Sync Uploaded Files to Task</span>

                                        <OverlayTrigger placement="top" overlay={renderSyncTooltip} delay={{ show: 150, hide: 100 }}>
                                        <span className="sync-files-info" tabIndex={0} role="button" aria-label="Sync ticket files info">
                                            <IoInformationCircleOutline />
                                        </span>
                                        </OverlayTrigger>
                                    </div>

                                    <Form.Check
                                        type="switch"
                                        id="sync-files-switch"
                                        checked={syncFiles}
                                        onChange={(e) => setSyncFiles(e.target.checked)}
                                        className="sync-files-switch sync-files-switch-lg"
                                    />
                                </div>
                            </div>
                            }
                            <div className="recent-tasks-cs">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-1 font_main_p">Recently Created Tasks</p>
                                    <IoRefreshOutline
                                        onClick={!recentLoading ? fetchRecentTasks : undefined}
                                        role="button"
                                        aria-label="Refresh recent tasks"
                                        className={recentLoading ? 'recent-tasks-refresh spinning' : 'recent-tasks-refresh'}
                                    />
                                </div>
                                {recentLoading && recentTasks.length === 0 && (
                                    <p className="recent-tasks-empty">Loading...</p>
                                )}
                                {!recentLoading && recentTasks.length === 0 && (
                                    <p className="recent-tasks-empty">No recent tasks found.</p>
                                )}
                                {recentTasks.length > 0 &&
                                <div className="recent-tasks-list">
                                    {recentTasks.map(task => {
                                        const assignees = task.assignees ?? []
                                        const hasDueDate = Number(task.task_due_date) > 0
                                        const isOverdue = hasDueDate && moment.unix(Number(task.task_due_date)).isBefore(moment(), 'day')
                                        const isDueToday = hasDueDate && !isOverdue && moment.unix(Number(task.task_due_date)).isSame(moment(), 'day')
                                        const dueState = isOverdue ? 'overdue' : (isDueToday ? 'today' : null)
                                        return (
                                        <div
                                            key={task.task_id}
                                            className="recent-task-card"
                                            role="button"
                                            onClick={!isLoading ? () => linkRecentTask(task) : undefined}
                                        >
                                            {task.tags?.length > 0 &&
                                            <div className="recent-task-tags">
                                                {task.tags.map(tag => (
                                                    <span
                                                        key={tag.tag_id}
                                                        className="recent-task-tag"
                                                        style={{backgroundColor: tag.tag_hex}}
                                                    >
                                                        {tag.tag_name}
                                                    </span>
                                                ))}
                                            </div>
                                            }
                                            {(task.workspace_name || task.project_name) &&
                                            <div className="recent-task-meta">
                                                <span className="recent-task-breadcrumb" title={[task.workspace_name, task.project_name].filter(Boolean).join(' / ')}>
                                                    {task.workspace_name}
                                                    {task.workspace_name && task.project_name &&
                                                        <span className="recent-task-breadcrumb-sep">/</span>
                                                    }
                                                    {task.project_name}
                                                </span>
                                            </div>
                                            }
                                            <div className="recent-task-name" title={task.task_text}>
                                                {task.task_text}
                                            </div>
                                            <div className="recent-task-footer">
                                                <div className="recent-task-footer-left">
                                                    {hasDueDate &&
                                                        <span className={`recent-task-due-pill${dueState ? ` recent-task-due-pill--${dueState}` : ''}`}>
                                                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
                                                                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                                            </svg>
                                                            <span className="recent-task-due-date-text">
                                                                {formatDateOnly(Number(task.task_due_date) * 1000)}
                                                            </span>
                                                        </span>
                                                    }
                                                </div>
                                                {assignees.length > 0 &&
                                                <div className="claritask-card-assignees">
                                                    {assignees.slice(0, 3).map(assignee => (
                                                        <span
                                                            key={assignee.user_id}
                                                            className="claritask-card-avatar"
                                                            data-fullname={`${assignee.first_name} ${assignee.last_name}`}
                                                        >
                                                            {assignee.first_name?.[0]}
                                                            {assignee.last_name?.[0]}
                                                        </span>
                                                    ))}
                                                </div>
                                                }
                                            </div>
                                        </div>
                                        )
                                    })}
                                </div>
                                }
                            </div>
                        </div>
                        <div>
                            <div className="timer-footer-btn">
                                <Button className="btn cancelLog" onClick={hideModal}>
                                    Cancel
                                </Button>
                                <Button
                                    className="btn logTime-timer"
                                    type="submit"
                                    disabled={isLoading}
                                    onClick={!isLoading ? () => linkTicket() : null}
                                >
                                    {isLoading ? 'Linking...' : 'Link Task'}
                                </Button>
                            </div>
                        </div>
                    </section>
                </div>
            </Modal>
        )
    )
}
export default LinkTask
